import React from "react"
import styled from "styled-components"

import Icon from "../Icon"
import Button, { ButtonProps } from "./button"

const Container = styled(Button)`
  margin: 15px 0;
  line-height: 24px;

  svg {
    vertical-align: middle;
    margin-right: 10px;
  }
`

const AppStoreButton = ({
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & ButtonProps) => (
  <Container {...props}>
    <Icon icon="app-store" />
    {children}
  </Container>
)

export default AppStoreButton
